export const environment = {
  appName: 'Stryker Medical Image Store',
  dl: {
    homepage: '#{datalab.ui.url}#',
    url: '#{datalab.api.url}#',
    scope: '#{datalab.api.externalUpload.scope}#',
    collection: {
      id: '#{sm.hipCheck.dataCollection.id}#',
      name: null!,
      dataProvider: {
        id: '#{sm.hipCheck.dataProvider.id}#',
        country: {
          code: '#{sm.hipCheck.countryCode}#'
        }
      }
    }
  },
  fus: {
    url: '#{fus.url}#',
    scope: '#{fus.scope.user}#',
    uploadedFor: '#{sm.fus.uploadedFor}#',
  },
  auth: {
    clientId: '#{sm.hipCheck.aad.clientID}#',
    authority: 'https://login.microsoftonline.com/#{tenantId}#',
    redirectUri: globalThis.location.origin,
    postLogoutRedirectUri: globalThis.location.origin
  }
};
